export const abTestTest = {
    id: 'AbTestTest',
    start: '2020-05-20',
    expiry: '2020-12-01',
    author: 'gtrufitt',
    description: 'This Test',
    audience: 0.0001,
    audienceOffset: 0,
    successMeasure: 'It works',
    audienceCriteria: 'Everyone',
    idealOutcome: 'It works',
    showForSensitive: true,
    canRun: () => true,
    variants: [
        {
            id: 'control',
            test: () => { },
            impression: (impression) => {
                impression();
            },
            success: (success) => {
                success();
            },
        },
        {
            id: 'variant',
            test: () => { },
            impression: (impression) => {
                impression();
            },
            success: (success) => {
                success();
            },
        },
    ],
};
